import React, { Component } from "react"
import { graphql } from "@apollo/client/react/hoc"
import { Row, Col, Nav, NavItem, NavLink, Container } from "reactstrap"
import gql from "graphql-tag"

import Loader from "../../Material/Loader"
import OverviewTab from "./PermissionDetailTab/OverviewTab"
import withApolloClient from "../../withApolloClient"

import "./PermissionDetails.css"

const PermissionQuery = gql`
  query Permission($id: ID!) {
    permission(id: $id) {
      id
      name
    }
  }
`

class PermissionDetails extends Component {
    state = {
        activeTab: "overview",
    }

    render() {
        const { permission, loading } = this.props
        if (loading) return <Loader />
        if (!permission) return null

        return (
            <Container fluid className="permission-details-page">
                <div className="permission-header">
                    <Row className="align-items-center">
                        <Col md="12">
                            <div className="permission-header-title">
                                <div className="permission-icon">
                                    <i className="fa fa-eye-slash" aria-hidden="true" />
                                </div>
                                <div>
                                    <div className="permission-title">
                                        {permission.name || "-"}
                                    </div>
                                    <div className="permission-subtitle">
                                        Permission
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Nav className="permission-tabs">
                    <NavItem>
                        <NavLink
                            className={this.state.activeTab === "overview" ? "active" : ""}
                            onClick={() => this.setState({ activeTab: "overview" })}
                        >
                            Overview
                        </NavLink>
                    </NavItem>
                </Nav>

                <div className="permission-content">
                    {this.state.activeTab === "overview" && (
                        <OverviewTab permissionId={permission.id} />
                    )}
                </div>
            </Container>
        )
    }
}

export default graphql(PermissionQuery, {
    options: (props) => ({
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        variables: {
            id: props.params.id,
        },
    }),
    props: ({ data: { permission, loading } }) => ({
        permission,
        loading,
    }),
})(withApolloClient(PermissionDetails))
